import {css, styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"
import {ColumnProps, ResponsiveColumnsProps, Width} from "."

type Breakpoints = typeof breakpoints.values
type Breakpoint = keyof Breakpoints

const MediaQueryGenerator = (sizes: Breakpoints, generateStyles: (breakpoint: Breakpoint) => string) => {
    return (Object.keys(sizes) as Breakpoint[]).map(breakpoint => {
        return `@media (min-width: ${sizes[breakpoint]}px) {
           ${generateStyles(breakpoint)}
        }
        `
    })
}

export const ColumnContainer = styled("section")<ResponsiveColumnsProps>`
    ${({columnsDefinition, nrOfColumns}) => {
        const result = MediaQueryGenerator(breakpoints.values, breakpoint => {
            const value = columnsDefinition?.[breakpoint]
            const isString = typeof value === "string" || value instanceof String
            const width: Width = (isString ? value : value?.[nrOfColumns]) as Width
            return `width: ${width};`
        })
        return css(result).styles
    }}
    gap: ${({gap}) => `${gap}`};
    display: flex;
    flex-wrap: ${({nrOfColumns}) => (nrOfColumns > 1 ? "wrap" : "nowrap")};
    flex-direction: ${({nrOfColumns}) => (nrOfColumns > 1 ? "row" : "column")};
`
/**
 * flex-basis: calculates the column width based on nrOfColumns and desired gap (aka space between them)
 * without creating gaps on the "edge columns" (top-left, top-right, bottom-left, bottom-right).
 * Eg: nrColumns = 3, gap = 15px
 * width = (100%/nrOfColumns) - (gap/nrOfColumns) * (nrOfColumns-1)
 * width = (100%/3)           - (15px/3)          * (3-1)
 * -1 reflects one whole edge column, representing the two sides which does not have a gap (left & right + top & bottom)
 */
export const Column = styled("div")<ColumnProps>`
    flex-basis: ${({nrOfColumns, gap}) => `calc(100% / ${nrOfColumns} - ${gap} / ${nrOfColumns} * ${nrOfColumns - 1})`};
`
